import fetch from '../core/fetch';
import { adminRole, districtAdminRole } from '../config';

/* eslint-disable import/prefer-default-export */
export const fetchEboiUser = (customerId, teryt) => fetch(`${process.env.API_URL}/testujemy/getCustomer?customerId=${customerId}&teryt=${teryt}`,
  { method: 'GET' })
  .then(r => {
    if (r.status === 200) {
      return r.json();
    }
    return null;
  });

export const fetchPrecints = (teryt) => fetch(`${process.env.API_URL}/eservices/${teryt}/precints`, {
  method: 'GET',
})
  .then(r => {
    return r.json();
  })
  .then(resp => {
    return resp.obreby;
  });


export const checkEpuapCertificate = (teryt) => fetch(`${process.env.API_URL}/eservices/check_certificate/${teryt}/`, {
  method: 'GET',
})
  .then(r => {
    let valid = false;
    if (r.status === 200) {
      valid = true;
    }
    return valid;
  });

// Return Arms according to district prefix
//http GET http://10.100.155.100:8000/api/v1.0/districts/arms/gmina_dmosin
// ${process.env.API_URL}/districts/arms/${prefix}
export const fetchArms = (prefix) => fetch(`${process.env.API_URL}/districts/arms/${prefix}`, {
  method: 'GET',
})
  .then(r => {
    return r.json();
  })
  .then(resp => {
    return resp.arms;
  });

export const getParcelsInPrecint = (district, precint) => fetch(
  `${process.env.API_URL}/eservices/${district}/${precint}/parcels`,
  { method: 'GET' })
  .then(r => r.json());

export const isUserLoggedIn = (state, query) => {
  if (!(state.user || query.customerId)) {
    const redirect = '/logowanieSAML';
    return { redirect };
  }
  return true;
}

export const fetchClaim = jobID => fetch(`${process.env.API_URL}/eservices/jobDetails/${jobID}`, {
  method: 'GET',
})
  .then(odp => {
    if (odp.status === 200) {
      return odp.json();
    } else return null;
  });

// /eservices/claim/status/<string:jobID>
export const fetchStatus = jobID => fetch(`/api/v1.0/eservices/claim/status/${jobID}`, {
  method: 'GET',
})
  .then(odp => {
    if (odp.status === 200) {
      return odp.json();
    } else return null;
  });

export const fetchDeliveryMethods = teryt => fetch(`${process.env.API_URL}/deliveryMethods/${teryt}`, {
  method: 'GET',
})
  .then(odp => {
    if (odp.status === 200) {
      return odp.json();
    } else return null;
  });

export const fetchMapState = teryt => fetch(`${process.env.API_URL}/mapstates/${teryt}`, {
  method: 'GET',
})
  .then(odp => {
    if (odp.status === 200) {
      return odp.json();
    } else return null;
  });

export const fetchPaymentMethods = (teryt) => fetch(`${process.env.API_URL}/paymentMethods/${teryt}`, {
  method: 'GET',
})
  .then(odp => {
    if (odp.status === 200) {
      return odp.json();
    } else return null;
  });

export const fetchDistricBankAccounts = teryt => fetch(`${process.env.API_URL}/prefix/${teryt}/bankAccounts`, {
  method: 'GET',
})
  .then(odp => {
    if (odp.status === 200) {
      return odp.json();
    } else return null;
  });

export const fetchAllDistricts = () => fetch(`${process.env.API_URL}/app_district`, {
  method: 'GET',
})
  .then(odp => {
    if (odp.status === 200) {
      return odp.json();
    } else return null;
  });

export const fetchAllServices = () => fetch(`${process.env.API_URL}/available_services/1`, {
  method: 'GET',
})
  .then(odp => {
    if (odp.status === 200) {
      return odp.json();
    } else return null;
  });

export const validateClaimOwnership = (claim, state) => {
  // returns true if claim belongs to user in store otherwise returns false
  if (state.user.username == 'habibi07') {
    return true;
  }
  return claim.fk_userID == state.user.ID;
}

export const isAdminUser = async ctx => {
  // Admin role name
  const state = await ctx.store.getState();
  if (!state.user) return false;
  if (!state.user.roles) return false;
  return state.user.roles.indexOf(adminRole) >= 0;
};

export const isDistrictAdminUser = async ctx => {
  const state = await ctx.store.getState();
  if (!state.user) return false;
  if (!state.user.roles) return false;
  return state.user.roles.indexOf(districtAdminRole) >= 0;
};

export const replaceMultipleSpaces = value => {
  return value.replace(/\s\s+/g, ' ');
};

export const getDistrictForUser = userID => {
  return fetch(`${process.env.API_URL}/users/getdistrict/${userID}/`, {
    method: 'GET',
  })
    .then(r => r.json())
    .then(resp => {
      return resp.district;
    });
};

export const fetchService = (teryt, shortName) =>
  fetch(`${process.env.API_URL}/eservice/${teryt}/${shortName}`, {
    method: 'GET',
  })
    .then(odp => {
      if (odp.status === 200) {
        return odp.json();
      } else return null;
    });


export const capitalizeFirstLetter = text => text ? text.charAt(0).toUpperCase() + text.slice(1) : null;

export const addVisit = (prefix, portal, serviceId=null) =>
  fetch(`${process.env.OLD_IHUB}/visit`, {
    method: 'POST',
    headers: {
        "Content-Type": "application/json",
    },
    body: JSON.stringify({
      gmina_prefix: prefix,
      portal: portal,
      service: serviceId
    })
  }).then(resp => {
      if (!resp.ok) {
        throw Error(resp.statusText);
      }
      return resp.json();
  })
  .catch(err => console.error(`Error occurred while fetching "${process.env.OLD_IHUB}/visit"`, err));

export const countAction = (prefix, portal, actionType, serviceId=null) =>
  fetch(`${process.env.OLD_IHUB}/action`, {
    method: 'POST',
    headers: {
        "Content-Type": "application/json",
    },
    body: JSON.stringify({
      gmina_prefix: prefix,
      portal: portal,
      action_target: serviceId,
      action_type: actionType
    })
  }).then(resp => {
      if (!resp.ok) {
        throw Error(resp.statusText);
      }
      return resp.json();
  })
  .catch(err => console.error(`Error occurred while fetching "${process.env.OLD_IHUB}/action"`, err));



// WEBPACK FOOTER //
// src/lib/utils.js